
/**
 * RDE共通コンテンツ
 */
export default {
  name: 'RdeCommonContents',
  methods: {
    getSrc(path) {
      return (this.$config.viewBaseUrl.basePath || '') + path;
    }
  }
};
